var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "category-basic" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            model: _vm.value,
            rules: _vm.rules,
            disabled: _vm.disabled,
            "label-width": "100px",
            "label-suffix": ":",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标题名称", prop: "home_index_name" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入",
                  clearable: "",
                  "show-word-limit": "",
                  maxlength: "10",
                },
                model: {
                  value: _vm.value.home_index_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "home_index_name", $$v)
                  },
                  expression: "value.home_index_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "菜单模式", prop: "menus_page_style" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.changeMenuStyle },
                  model: {
                    value: _vm.value.menus_page_style,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "menus_page_style", $$v)
                    },
                    expression: "value.menus_page_style",
                  },
                },
                [
                  _c(
                    "el-radio",
                    { attrs: { label: 3 } },
                    [
                      _vm._v(" 默认菜单 "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content:
                              "默认规则的处理逻辑，开放式商城：与首页装修同步；封闭式商城：按卡规则加载",
                            placement: "top",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(" 自定义菜单 "),
                  ]),
                  _vm.isCustomer
                    ? _c("el-radio", { attrs: { label: 4 } }, [
                        _vm._v(" 应用渠道模式 "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.canConfigStyle
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "显示风格",
                      prop: "menus_page_interaction_style",
                    },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.value.menus_page_interaction_style,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "menus_page_interaction_style",
                              $$v
                            )
                          },
                          expression: "value.menus_page_interaction_style",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("经典风格"),
                        ]),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("缤纷风格"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "主题色", prop: "menus_page_theme_color" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "theme-color-row" },
                      [
                        _c("el-color-picker", {
                          attrs: { predefine: _vm.predefineColors },
                          model: {
                            value: _vm.value.menus_page_theme_color,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "menus_page_theme_color", $$v)
                            },
                            expression: "value.menus_page_theme_color",
                          },
                        }),
                        _c("el-input", {
                          staticClass: "theme-color-input",
                          attrs: {
                            placeholder: "请输入6位十六进制颜色值",
                            maxlength: "7",
                          },
                          on: { blur: _vm.formatThemeColor },
                          model: {
                            value: _vm.value.menus_page_theme_color,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "menus_page_theme_color", $$v)
                            },
                            expression: "value.menus_page_theme_color",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "theme-color-reset",
                            on: { click: _vm.resetThemeColor },
                          },
                          [_vm._v(" 重置默认色 ")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }